import { Select } from 'antd';
import { CountryFlag } from './CountryFlag';
import type { Circuit } from '../../api/circuitsService';

export interface CircuitSelectorProps {
  circuits: Circuit[];
  value?: string | null;
  onChange?: (circuitId: string | null) => void;
  loading?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
}

/**
 * Styled like the header EventSelector: flag + circuit name, without date or location suffix.
 */
export const CircuitSelector: React.FC<CircuitSelectorProps> = ({
  circuits,
  value,
  onChange,
  loading = false,
  placeholder = 'Select circuit',
  style,
}) => {
  const sorted = [...circuits].sort((a, b) =>
    a.display_name.localeCompare(b.display_name, undefined, { sensitivity: 'base' })
  );

  const circuitOptionLabel = (c: Circuit) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <CountryFlag
        country={c.country}
        style={{
          width: 18,
          height: 13,
          objectFit: 'cover',
        }}
        title={c.country}
      />
      <span>{c.display_name}</span>
    </div>
  );

  return (
    <Select
      value={value ?? undefined}
      onChange={(id) => onChange?.(id ?? null)}
      loading={loading}
      placeholder={placeholder}
      allowClear
      style={{ minWidth: 280, ...style }}
      showSearch={{
        filterOption: (input, option) => {
          const id = option?.value as string | undefined;
          if (!id) return false;
          const c = sorted.find((x) => x.circuit_id === id);
          if (!c) return false;
          const q = input.toLowerCase();
          return (
            c.display_name.toLowerCase().includes(q) ||
            c.circuit_id.toLowerCase().includes(q) ||
            c.location_name.toLowerCase().includes(q)
          );
        },
      }}
      options={sorted.map((c) => ({
        value: c.circuit_id,
        label: circuitOptionLabel(c),
      }))}
    />
  );
};

export default CircuitSelector;
